<template>
  <base-page>
    <titlu-pagina Titlu="Devize in lucru" :AdaugaVisible="false"></titlu-pagina>
    <el-card id="card">
      <div slot="header" class="clearfix">
        <strong>Service</strong> |
        <span class="tag-logged">Service-evio</span>
      </div>
      <div class="main-div">
        <div v-for="(d, index) in devize" :key="'deviz' + d.Id">
          {{ showDialogIncheiere[index] }}

          <div class="menu">
            <div :id="d.Id" class="deviz" :style="getBackgroundStyle(d)">

              <div class="header ora" style="font-size:13px;">
                <div
                  style="display: flex; justify-content: space-between; align-items:center; width:100%; margin-top:24px;gap:12px;">
                  <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; white-space: nowrap;" v-if="$has_right('Supervizor')"> 
                    <span>{{ d.NumeMecanic }}</span>
                    <span v-if="d.NumeAjutorMontator">{{ d.NumeAjutorMontator }}</span>
                    <span v-else>(fara ajutor)</span>
                  </div>
                  <span>Programare: {{ d.DataRezervarii | OraFaraSec }}</span>
                  <CountdownTimer :key="'deviz' + d.Id" :deviz="d" :countdown="countdowns[index]" />
                </div>

              </div>
              <div class="header">
                <!-- <p>{{d.NumeClient}}</p> -->
                <p>{{ d.Numar }}</p>
                <el-tooltip class="item" effect="dark" content="Goleste" placement="right"
                  v-if="$has_right('Supervizor') && d.NumarProduse > 0">
                  <el-button size="mini" type="danger" v-if="d.DataPreluareInLucru" @click="goleste(d, index)" circle><i
                      class="el-icon-delete"></i></el-button>
                </el-tooltip>
              </div>
              <div class="old-main" v-if="d.DataPreluareInLucru">
                <div class="main">
                  <span v-if="d.MotivRespingere" class="mic mesaj-respins">Respins: {{ d.MotivRespingere }}</span>
                  <el-button :class="!d.MotivRespingere ? 'mare' : 'mic'" type="success"
                    :disabled="d.NumarProduse == 0 && !$has_right('Supervizor')"
                    @click="triggerDeviz('deviz_produse', d.Id, d)">
                    <span v-if="d.NumarProduse == 0 && !$has_right('Supervizor')">Devizul este gol!</span>
                    <span v-else>Deviz</span>
                  </el-button>

                </div>
                <div class="footer">
                  <el-button style="display: flex; justify-content: center; align-items: center;" type="warning" @click="alegeTipAuto(d, index)">Tip auto</el-button>
                  <el-button style="display: flex; justify-content: center; align-items: center;" type="success" @click="validare_deviz(d, index)"
                    :disabled="d.NumarProduse == 0">Inchidere</el-button>
                </div>
              </div>
              <div v-else class="main-new">
                <el-button style="display: flex; justify-content: center; align-items: center;" type="success" class="deviz-nou" @click="incepeLucrarea(d, index)">Incepe
                  lucrarea</el-button>
                <el-button style="display: flex; justify-content: center; align-items: center;" v-if="$has_right('Supervizor')" size="mini" type="danger" @click="inchide_deviz(d, index)"
                  :disabled="d.NumarProduse > 0">Lipsa operatiune</el-button>
              </div>
              <div style="display: flex; justify-content: center; align-items: center;">
                <span class="cant_span" v-if="d.Hotel == 1">HOTEL</span>
                <span v-else>&nbsp;</span>
              </div>
           
              <el-row class="deviz-row" :gutter="20" v-if="d.OptiuneCantitati == 'sursa_destinatie'">
                <el-col :span="12">
                  <div class="deviz-source-title">Sursa</div>

                  <div style="display: flex; flex-direction: column; font-weight: bold">
                    <div v-if="d && d.SursaHotel" style="display: flex; justify-content: space-between;">
                      <span>Hotel</span>
                      <span>{{ d.SursaHotel }}</span>
                    </div>
                    <div v-else style="height: 0.5em;">&nbsp;</div>

                    <div v-if="d && d.SursaPersonala" style="display: flex; justify-content: space-between;">
                      <span>Anvelope proprii</span>
                      <span>{{ d.SursaPersonala }}</span>
                    </div>
                    <div v-else style="height: 0.5em;">&nbsp;</div>

                    <div v-if="d && d.SursaComanda" style="display: flex; justify-content: space-between;">
                      <span>Comanda noua</span>
                      <span>{{ d.SursaComanda }}</span>
                    </div>
                    <div v-else style="height: 0.5em;">&nbsp;</div>
                  </div>
                </el-col>

                <el-col :span="12">
                  <div class="deviz-source-title" >Destinație</div>

                  <div style="display: flex; flex-direction: column; font-weight: bold">
                    <div v-if="d && d.DestinatieReciclare" style="display: flex; justify-content: space-between;">
                      <span>Reciclare</span>
                      <span>{{ d.DestinatieReciclare }}</span>
                    </div>
                    <div v-else style="height: 0.5em;">&nbsp;</div>

                    <div v-if="d && d.DestinatieHotel" style="display: flex; justify-content: space-between;">
                      <span>Hotel</span>
                      <span>{{ d.DestinatieHotel }}</span>
                    </div>
                    <div v-else style="height: 0.5em;">&nbsp;</div>

                    <div v-if="d && d.DestinatieReturnare" style="display: flex; justify-content: space-between;">
                      <span>Returnare</span>
                      <span>{{ d.DestinatieReturnare }}</span>
                    </div>
                    <div v-else style="height: 0.5em;">&nbsp;</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog :title="'Deviz #' + this.mod_deviz.IdDevizModif" :close-on-press-escape="false" :fullscreen="true"
      :visible.sync="showDialogMasina" width="80%" append-to-body>
      <div class="select-container">
        <p>Alege modelul autovehiculului</p>
        <div class="btn-auto-group">
          <el-button class="btn-auto" @click="schimba_tip('tip', 'Normal')"
            :type="mod_deviz.TipAutoModif === 'Normal' ? 'primary' : ''">Normal</el-button>
          <el-button class="btn-auto" @click="schimba_tip('tip', 'SUV')"
            :type="mod_deviz.TipAutoModif === 'SUV' ? 'primary' : ''">SUV</el-button>
          <el-button class="btn-auto" @click="schimba_tip('tip', 'Autoutilitar')"
            :type="mod_deviz.TipAutoModif === 'Autoutilitar' ? 'primary' : ''">Autoutilitar</el-button>
             <el-button class="btn-auto" @click="schimba_tip('tip', 'Supercar')"
            :type="mod_deviz.TipAutoModif === 'Supercar' ? 'primary' : ''">Supercar</el-button>
        </div>
      </div>
      <div v-if="mod_deviz.IncludeRotiInInspectie != 0">
        <!-- <div v-if="mod_deviz.AscundeTipAnvelope !== '1'" class="select-container">
          <p>Alege tipul anvelopelor</p>
          <div class="btn-auto-group">
            <el-button class="btn-auto" @click="schimba_tip('anvelope', 'Noi')"
              :type="mod_deviz.TipAnvelope === 'Noi' ? 'primary' : ''">Anvelope noi</el-button>
            <el-button class="btn-auto" @click="schimba_tip('anvelope', 'Vechi')"
              :type="mod_deviz.TipAnvelope === 'Vechi' ? 'primary' : ''">Anvelope vechi</el-button>
            <el-button class="btn-auto" @click="schimba_tip('anvelope', 'Hotel')"
              :type="mod_deviz.TipAnvelope === 'Hotel' ? 'primary' : ''">Anvelope hotel</el-button>
          </div>
        </div> -->
        <div class="masina">
          <div class="left">
            <div class="roata" @click="modifica_roata(0)">
              <div class="chestionar">
                <p>Roata #1</p>
                <!-- <el-checkbox :disabled="roti.filter(roata => roata.verificata == true).length ==  mod_deviz.NrRoti && !roti[0].verificata" v-model="roti[0].janta_avariata">Janta zgariata</el-checkbox> -->
                <div style="display: flex; gap: 8px;">
                  <div style="display:flex; flex-direction: column; gap:10px">
                    <span>Diametru</span>
                    <el-select
                      @change="valideaza_roti(0, mod_deviz)"
                      v-model="diametruInitialFata"
                      placeholder="Selectează diametru"
                      size="mini"
                      style="flex: 1"
                      :disabled="(roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[0].verificata) && (mod_deviz.CantitateStandard != 1)"
                    >
                      <el-option
                        v-for="opt in diametruOptions"
                        :key="opt"
                        :label="opt"
                        :value="opt"
                      />
                    </el-select>
                  </div>
                  <div style="display:flex; flex-direction: column; gap: 10px">
                    <span>Similar spate</span>
                    <el-checkbox v-model="diametruSimilarValue" @change="diametru_similar()" style="flex: 1"></el-checkbox>
                  </div>
                </div>
                <span>Aspectul jantei</span>
                <el-radio-group size="mini" v-model="roti[0].starea_jantei" @change="valideaza_roti(0, mod_deviz)"
                  :disabled="(roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[0].verificata) && (mod_deviz.CantitateStandard != 1)">
                  <el-radio-button style="margin: 0px 6px 0px 0px;" label="Proasta">
                  </el-radio-button>
                  <el-radio-button style="margin: 0px 6px 0px 6px;border-left: 1px solid #e2dddd;"
                    label="Buna"></el-radio-button>
                  <el-radio-button style="margin: 0px 0px 0px 6px;border-left: 1px solid #e2dddd"
                    label="Foarte buna"></el-radio-button>
                </el-radio-group>
              </div>
              <img src="../../../assets/roata.svg"
                :style="[roti[0].verificata ? add_filter_effect(true) : add_filter_effect(false), { marginTop: '40px' }]"
                alt="roata" />
            </div>
            <div class="roata" @click="modifica_roata(1)">
              <div class="chestionar">
                <p>Roata #2</p>
                <!-- <el-checkbox :disabled="roti.filter(roata => roata.verificata == true).length ==  mod_deviz.NrRoti && !roti[1].verificata" v-model="roti[1].janta_avariata">Janta zgariata</el-checkbox> -->
                <div style="display: flex; gap: 8px;">
                  <div style="display:flex; flex-direction: column; gap:10px">
                    <span>Diametru</span>
                    <el-select @change="valideaza_roti(1, mod_deviz)" v-model="diametruInitialSpate" placeholder="Selectează diametru" size="mini" style="width: 100%"
                      :disabled="((roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[1].verificata) && (mod_deviz.CantitateStandard != 1)) || (diametruSimilarValue)">
                      <el-option v-for="opt in diametruOptions" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                  </div>
                  <div style="display:flex; flex-direction: column; gap: 10px">
                    <span>Similar spate</span>
                    <el-checkbox v-model="diametruSimilarValue" @change="diametru_similar()" style="flex: 1"></el-checkbox>
                  </div>
                </div>
                <span>Aspectul jantei</span>
                <el-radio-group size="mini" v-model="roti[1].starea_jantei" @change="valideaza_roti(1, mod_deviz)"
                  :disabled="(roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[1].verificata) && (mod_deviz.CantitateStandard != 1)">
                  <el-radio-button style="margin: 0px 6px 0px 0px;" label="Proasta"></el-radio-button>
                  <el-radio-button style="margin: 0px 6px 0px 6px;border-left: 1px solid #e2dddd;"
                    label="Buna"></el-radio-button>
                  <el-radio-button style="margin: 0px 0px 0px 6px;border-left: 1px solid #e2dddd"
                    label="Foarte buna"></el-radio-button>
                </el-radio-group>
              </div>
              <img src="../../../assets/roata.svg"
                :style="[roti[1].verificata ? add_filter_effect(true) : add_filter_effect(false), { marginTop: '40px' }]"
                alt="roata" />
            </div>
          </div>
          <div class="center">
            <img src="../../../assets/m.svg" alt="masina" />
          </div>
          <div class="right">
            <div class="roata" @click="modifica_roata(2)">
              <div class="chestionar">
                <p>Roata #3</p>
                <!-- <el-checkbox :disabled="roti.filter(roata => roata.verificata == true).length ==  mod_deviz.NrRoti && !roti[2].verificata" v-model="roti[2].janta_avariata">Janta zgariata</el-checkbox> -->
                 <div style="display: flex; gap: 8px;">
                  <div style="display:flex; flex-direction: column; gap:10px">
                    <span>Diametru</span>
                    <el-select @change="valideaza_roti(2, mod_deviz)" v-model="diametruInitialFata" placeholder="Selectează diametru" size="mini" style="width: 100%"
                    :disabled="((roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[2].verificata) && (mod_deviz.CantitateStandard != 1))">
                      <el-option v-for="opt in diametruOptions" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                  </div>
                  <div style="display:flex; flex-direction: column; gap: 10px">
                    <span>Similar spate</span>
                    <el-checkbox v-model="diametruSimilarValue" @change="diametru_similar()" style="flex: 1"></el-checkbox>
                  </div>
                </div>
                <span>Aspectul jantei</span>
                <el-radio-group size="mini" v-model="roti[2].starea_jantei" @change="valideaza_roti(2, mod_deviz)"
                  :disabled="(roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[2].verificata) && (mod_deviz.CantitateStandard != 1)">
                  <el-radio-button style="margin: 0px 6px 0px 0px;" label="Proasta"></el-radio-button>
                  <el-radio-button style="margin: 0px 6px 0px 6px;border-left: 1px solid #e2dddd;"
                    label="Buna"></el-radio-button>
                  <el-radio-button style="margin: 0px 0px 0px 6px;border-left: 1px solid #e2dddd"
                    label="Foarte buna"></el-radio-button>
                </el-radio-group>
              </div>
              <img src="../../../assets/roata.svg"
                :style="[roti[2].verificata ? add_filter_effect(true) : add_filter_effect(false), { marginTop: '40px' }]"
                alt="roata" />
            </div>
            <div class="roata" @click="modifica_roata(3)">
              <div class="chestionar">
                <p>Roata #4</p>
                <!-- <el-checkbox :disabled="roti.filter(roata => roata.verificata == true).length ==  mod_deviz.NrRoti && !roti[3].verificata" v-model="roti[3].janta_avariata">Janta zgariata</el-checkbox> -->
                <div style="display: flex; gap: 8px;">
                  <div style="display:flex; flex-direction: column; gap:10px">
                    <span>Diametru</span>
                    <el-select @change="valideaza_roti(3, mod_deviz)" v-model="diametruInitialSpate" placeholder="Selectează diametru" size="mini" style="width: 100%"
                    :disabled="((roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[3].verificata) && (mod_deviz.CantitateStandard != 1)) || (diametruSimilarValue)">
                      <el-option v-for="opt in diametruOptions" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                  </div>
                  <div style="display:flex; flex-direction: column; gap: 10px">
                    <span>Similar spate</span>
                    <el-checkbox v-model="diametruSimilarValue" @change="diametru_similar()" style="flex: 1"></el-checkbox>
                  </div>
                </div>
                <span>Aspectul jantei</span>
                <el-radio-group size="mini" v-model="roti[3].starea_jantei" @change="valideaza_roti(3, mod_deviz)"
                  :disabled="(roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[3].verificata) && (mod_deviz.CantitateStandard != 1)">
                  <el-radio-button style="margin: 0px 6px 0px 0px;" label="Proasta"></el-radio-button>
                  <el-radio-button style="margin: 0px 6px 0px 6px;border-left: 1px solid #e2dddd;"
                    label="Buna"></el-radio-button>
                  <el-radio-button style="margin: 0px 0px 0px 6px;border-left: 1px solid #e2dddd"
                    label="Foarte buna"></el-radio-button>
                </el-radio-group>
              </div>
              <img src="../../../assets/roata.svg"
                :style="[roti[3].verificata ? add_filter_effect(true) : add_filter_effect(false), { marginTop: '40px' }]"
                alt="roata" />
            </div>
          </div>
        </div>
        <div v-if="mod_deviz.NrRoti > 4 && mod_deviz.CantitateStandard != 1" class="roti-suplimentare">
          <p>Roti suplimentare</p>
          <div class="roti-list">
            <div v-for="n in (this.mod_deviz.NrRoti - 4)" :key="'roata_suplimentara_' + n" class="roata">
              <img src="../../../assets/roata.svg"
                :style="roti[n + 3].verificata ? add_filter_effect(true) : add_filter_effect(false)"
                @click="modifica_roata(n + 3)" />
            </div>
          </div>
        </div>
      </div>
      <el-dialog append-to-body :visible.sync="show_roata_dialog" width="400px">
        <div style='display:flex;flex-direction:column;justify-content:center;gap:12px;padding:12px'>
          <div>
            <span>Roata #{{ temp_roata.index + 1 }}</span>
          </div>
          <div style="display:flex; flex-direction: column; gap:10px">
            <span>Diametru</span>
            <el-select
              v-model="temp_roata.object.diametru_initial"
              placeholder="Selectează diametru"
              size="mini"
              style="flex: 1"
              :disabled="roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[temp_roata.index].verificata"
            >
              <el-option
                v-for="opt in diametruOptions"
                :key="opt"
                :label="opt"
                :value="opt"
              />
            </el-select>
          </div>
          <div>
            <span>Aspectul jantei</span>
          </div>
          <div>
            <el-radio-group size="mini" v-model="temp_roata.object.starea_jantei"
              :disabled="roti.filter(roata => roata.verificata == true).length == mod_deviz.NrRoti && !roti[temp_roata.index].verificata">
              <el-radio-button style="margin: 0px 6px 0px 0px;" label="Proasta"></el-radio-button>
              <el-radio-button style="margin: 0px 6px 0px 6px;border-left: 1px solid #e2dddd;"
                label="Buna"></el-radio-button>
              <el-radio-button style="margin: 0px 0px 0px 6px;border-left: 1px solid #e2dddd"
                label="Foarte buna"></el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="inchide_roata()"> Renunta </el-button>
          <el-button type="primary" @click="save_roata()"> Salveaza </el-button>
        </span>
      </el-dialog>
      <el-card shadow="always" style="width:100%;margin-top:54px; padding: 0%" v-if="!displayTorqButton">
        <el-form size="mini" label-position="top" :inline="false" label-width="100%" :model='wheelApiObject'
          :ref="'my-wheel-form'" :rules='rulesWheel'>
          <div slot="header" class="clearfix">
            <span>Informatii necesare</span>
          </div>
          <div style="display:flex;justify-content:center;align-items:center;gap:10px;">
            <el-form-item class="full-width" label="Marca" prop="Marca">
              <el-input v-model="wheelApiObject.Marca" />
            </el-form-item>
            <el-form-item class="full-width" label="Model" prop="Model">
              <el-input v-if="!noDataFound" v-model="wheelApiObject.Model" />
              <el-select class="full-width" v-else v-model="wheelApiObject.Model">
                <el-option v-for="item in wheelsModelsData" :key="'model_' + item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="full-width" label="An" prop="An">
              <el-input v-model="wheelApiObject.An" @input="inputNumberHandler()" />
            </el-form-item>
          </div>
          <div class="full-width bottom clearfix" style="display:flex;justify-content:flex-end">
            <el-button size="mini" type="success" class="button" @click="sendInfoToWheelApi()">Trimite</el-button>
          </div>
        </el-form>
      </el-card>
      <el-row :gutter="5" style="margin-top:120px;">
        <el-col :sm="24">
          <div style="display:flex;justify-content:flex-end;align-items:center;margin-bottom:12px;">
            <el-button size="mini" v-if='wheelResponseObject.length != 0'
              @click="hideWheelsInfoHandler">Ascunde</el-button>
          </div>
        </el-col>
        <el-col :sm="12" :md="8" :lg="6" v-for="(wheel, index) in wheelResponseObject.data" :key="index">
          <el-card :header="wheel.title" style="margin-bottom: 10px;line-height:18px; padding: 0px;">
            <div slot="header" class="clearfix">
              <!-- {{wheel.make.name}} {{wheel.model.name}} -  -->
              <span style="font-weight:bold;font-size:15px">{{ wheel.engine.capacity }}
                {{ wheel.engine.fuel == 'Petrol' ? "Benzina" : wheel.engine.fuel }} {{ wheel.engine.power.hp }} CP
                ({{ wheel.start_year }} - {{ wheel.end_year }})</span>
            </div>
            <div style="display:flex;">
              <div style="width:190%">
                <div class="full-width">
                  <table style="text-align:center !important;" border class="full-width">
                    <tr style="border: 1px black solid;">
                      <td><strong>Anvelope</strong></td>
                      <th>Fata</th>
                      <th> Spate</th>
                    </tr>
                    <tr v-for="index in wheel.wheels.length" :key="index" border>
                      <td><span>{{ wheel.wheels[index - 1].front.tire }}</span></td>
                      <td>{{ wheel.wheels[index - 1].front.tire_pressure.bar }}</td>
                      <td>{{ wheel.wheels[index - 1].rear.tire_pressure.bar }}</td>
                    </tr>
                  </table>
                  <div class="full-width">
                    <span>Cuplu strangere roti: <strong>{{ wheel.technical.wheel_tightening_torque }}</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">

        <el-button @click="inchideDialogMasina(mod_deviz.IdDevizModif)"> Renunta </el-button>
        <el-button v-if="mod_deviz.ObtineInformatiiAditionale != 0" type="info" @click="getTorqPressure()"
          :disabled="!displayTorqButton || wheelResponseObject.length != 0"> Obtine informatii aditionale</el-button>
        <el-button type="primary" @click="schimba_tip_auto()"> Alege </el-button>
      </span>
    </el-dialog>

    <el-dialog title="Inspectie finala" :visible.sync="showDialogIncheiere" width="90%">
      <el-form size="mini" label-position="top" :inline="false" label-width="100%" :model='inspectie' :ref="'my-form'"
        :rules='rules'>
        <el-row :gutter="15">
          <el-col :sm="8" :md="8" :xs="9">
            <el-form-item class="input-inspectie" label='Presiune fata' prop="PresiuneRoti">
              <el-input-number v-model="inspectie.PresiuneRoti" style="width:100% !important" :precision="1" :step="0.1"
                :min="1.5" :max="5"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="5" :md="8" :xs="6">
            <el-form-item label="Pres. spate = fata">
              <div style="display:flex; align-items:center; justify-content:center; width:100%;">
                <el-checkbox v-model="presiuneEgala" true-label="1" false-label="0"></el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :xs="9">
            <el-form-item class="input-inspectie" label='Presiune spate' prop="PresiuneRotiSpate">
              <el-input-number v-model="inspectie.PresiuneRotiSpate" :disabled="presiuneEgala == '1'"
                style="width:100% !important" :precision="1" :step="0.1" :min="1.5" :max="5"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col v-if="inspectie.CupluInInspectie == 1" :sm="8" :md="8" :xs="9">
            <el-form-item class="input-inspectie" label='Cuplu de strangere (fata)' prop="Cuplu">
              <el-input-number style="width:100% !important" v-model="inspectie.Cuplu" :precision="0" :step="5"
                :min="50" :max="800" />
            </el-form-item>
          </el-col>
          <el-col v-if="inspectie.CupluInInspectie == 1" :sm="8" :md="8" :xs="6">
            <el-form-item label="Cuplu spate = fata">
              <div style="display:flex; align-items:center; justify-content:center; width:100%;">
                <el-checkbox v-model="cupluEgal" true-label="1" false-label="0"></el-checkbox>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="inspectie.CupluInInspectie == 1" :sm="8" :md="8" :xs="9">
            <el-form-item class="input-inspectie" label='Cuplu de strangere (spate)' prop="Cuplu">
              <el-input-number style="width:100% !important" v-model="inspectie.CupluSpate" :disabled="cupluEgal == '1'"
                :precision="0" :step="5" :min="50" :max="800" />
            </el-form-item>
          </el-col>

          <el-col v-if="inspectie.CantitateStandard != 1" :sm="8" :md="3">
            <el-form-item class="input-inspectie" label="Antifurt">
              <el-checkbox style="width:100% !important" v-model="inspectie.Antifurt" true-label="1" false-label="0">
                A avut antifurt
              </el-checkbox>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row v-for="(item, i) in stareAnvelopeObj" :key="item.index" :span="24">
          <el-col>
            <el-form-item :label="`Stare anvelopa #${parseInt(item.index) + 1}`">
              <el-radio-group size="mini" v-model="item.valoare">
                <el-radio-button label="Crapata" />
                <el-radio-button label="Taiata" />
                <el-radio-button label="Perforata" />
                <el-radio-button label="Uzata" />
                <el-radio-button label="Buna" />
                <el-radio-button label="Noua" />
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="`Diametru final #${parseInt(item.index) + 1}` " v-if="diametruAnvelopeObj[i]">

              <div style="display:flex;gap:10px;" v-if="i === 0 || i === 2">
                <el-select
                  v-model="diametruFinalFata"
                  placeholder="Selectează diametru"
                  size="mini"
                  style="width: 25%"
                >
                  <el-option
                    v-for="opt in diametruOptions"
                    :key="opt"
                    :label="opt"
                    :value="opt"
                  />
                </el-select>
              </div>
              <div style="display:flex;gap:10px;" v-else-if="i === 1 || i === 3">
                <el-select
                  v-model="diametruFinalSpate"
                  placeholder="Selectează diametru"
                  size="mini"
                  style="width: 25%"
                >
                  <el-option
                    v-for="opt in diametruOptions"
                    :key="opt"
                    :label="opt"
                    :value="opt"
                  />
                </el-select>
              </div>
              <el-select
                v-else
                v-model="diametruAnvelopeObj[i].diametru_final"
                placeholder="Selectează diametru"
                size="mini"
                style="width: 25%"
              >
                <el-option
                  v-for="opt in diametruOptions"
                  :key="opt"
                  :label="opt"
                  :value="opt"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="16">
            <el-form-item label="Observatie" prop="Observatie">
              <el-input v-model="selectedObject.Observatie" clearable size="mini" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="Observatii prestabilite">
              <el-checkbox-group @change="selectObservatieHandler" style="width: 100%"
                v-model="selectedObject.CheckedObsArr" size="mini">
                <el-checkbox style="width: 100%;margin-left:0px !important" v-for="obs in Info.Observatii"
                  :key="obs.observatie" :label="obs.observatie" border />
              </el-checkbox-group>
              <div v-for="obs in observatiiPredefiniteDetaliate" :key="obs.observatiePredefinita"
                style="margin-top: 5px; margin-left: 10px;">
                <strong>{{ obs.observatiePredefinita }}</strong>
                <ul style="margin: 0; padding-left: 20px;">
                  <li v-for="(roata, index) in obs.roti" :key="index">
                    Roata {{ roata.index + 1 }}: cantitate - {{ roata.qty }}
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5" style="display:flex;justify-content:center;align-items:center">
          <el-card shadow="always" style="width:100%;margin-top:0px; padding: 0%" v-if="!displayTorqButton">
            <el-form size="mini" label-position="top" :inline="false" label-width="100%" :model='wheelApiObject'
              :ref="'my-wheel-form'" :rules='rulesWheel'>
              <div slot="header" class="clearfix">
                <span>Informatii necesare</span>
              </div>
              <div style="display:flex;justify-content:center;align-items:center;gap:10px;">
                <el-form-item class="full-width" label="Marca" prop="Marca">
                  <el-input v-model="wheelApiObject.Marca" />
                </el-form-item>
                <el-form-item class="full-width" label="Model" prop="Model">
                  <el-input v-if="!noDataFound" v-model="wheelApiObject.Model" />
                  <el-select class="full-width" v-else v-model="wheelApiObject.Model">
                    <el-option v-for="item in wheelsModelsData" :key="'model_' + item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="full-width" label="An" prop="An">
                  <el-input v-model="wheelApiObject.An" @input="inputNumberHandler()" />
                </el-form-item>
              </div>
              <div class="full-width bottom clearfix" style="display:flex;justify-content:flex-end">
                <el-button size="mini" type="success" class="button" @click="sendInfoToWheelApi()">Trimite</el-button>
              </div>
            </el-form>
          </el-card>
        </el-row>

        <el-row :gutter="5">
          <el-col :sm="12" :md="8" :lg="6" v-for="(wheel, index) in wheelResponseObject.data" :key="index">
            <el-card :header="wheel.title" style="margin-bottom: 10px;line-height:18px; padding: 0px;">
              <div slot="header" class="clearfix">
                <!-- {{wheel.make.name}} {{wheel.model.name}} -  -->
                <span style="font-weight:bold;font-size:15px">{{ wheel.engine.capacity }}
                  {{ wheel.engine.fuel == 'Petrol' ? "Benzina" : wheel.engine.fuel }} {{ wheel.engine.power.hp }} CP
                  ({{ wheel.start_year }} - {{ wheel.end_year }})</span>
              </div>
              <div style="display:flex;">
                <div style="width:190%">
                  <!-- <div class="full-width">
                    <span>Ani productie: {{wheel.start_year}} - {{ wheel.end_year }}</span>
                  </div> -->

                  <!-- <div class="full-width">
                    <span>Tip roti(fata): {{ wheel.frontTierType }}</span>
                  </div>
                  <div class="full-width">
                    <span>Tip roti(spate): {{ wheel.rearTierType}}</span>
                  </div>
                  <div class="full-width">
                    <span>Presiune roti(fata):{{ wheel.frontTierPressure }} bar</span>
                  </div>
                  <div class="full-width">
                    <span>Presiune roti(spate):{{ wheel.rearTierPressure }} bar</span>
                  </div> -->
                  <div class="full-width">
                    <table style="text-align:center !important;" border class="full-width">
                      <tr style="border: 1px black solid;">
                        <td><strong>Anvelope</strong></td>
                        <th>Fata</th>
                        <th> Spate</th>
                        <th></th>
                      </tr>
                      <tr v-for="index in wheel.wheels.length" :key="index" border>
                        <td><span>{{ wheel.wheels[index - 1].front.tire }}</span></td>
                        <td>{{ wheel.wheels[index - 1].front.tire_pressure.bar }}</td>
                        <td>{{ wheel.wheels[index - 1].rear.tire_pressure.bar }}</td>
                        <td>
                          <el-tooltip class="item" effect="dark" content="Foloseste aceste informatii"
                            placement="top-start">
                            <el-button size="mini" style="padding:1px;" type="success" icon="el-icon-check" circle
                              @click="saveWheelInfo(wheel.wheels[index - 1], wheel.technical.wheel_tightening_torque)" />
                          </el-tooltip>
                        </td>
                      </tr>
                    </table>
                    <div class="full-width">
                      <span>Cuplu strangere roti: <strong>{{ wheel.technical.wheel_tightening_torque }}</strong></span>
                    </div>
                  </div>



                </div>
                <!-- <div class="full-width">
                <pre>{{ wheel.wheels[0]}}</pre>
                </div> -->


                <!-- --{{ wheel.frontTierType[0]}} ±{{ wheel.frontTierType[1]}}±{{ wheel.frontTierType [2]}} error--text -->

                <!-- <div  style="float; color: red" v-for="index in wheel.wheels.length" :key="index"> -->
                <!-- {{ wheel.wheels[index-1].front.tire_pressure.hasOwnProperty("bar") }} -->
                <!-- 
                  <pre>{{ wheel.wheels[index-1].front.tire }}</pre>
                  <pre>{{ wheel.wheels[index-1].front.tire_pressure.bar }}</pre>
                  <pre>{{ wheel.wheels[index-1].rear.tire_pressure.bar }}</pre>
                </div> -->
                <!-- 
                <div style="float; margin-left:5px;">
                  <img :src="wheel.generation.bodies[0].image" alt="Imagine" style="max-width: 80%; height: auto;">
                </div> -->
              </div>

            </el-card>
          </el-col>

        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogIncheiere = false"> Renunta </el-button>
        <el-button v-if="inspectie.ObtineInformatiiAditionale != 0" type="info" @click="getTorqPressure()"
          :disabled="!displayTorqButton || wheelResponseObject.length != 0"> Obtine informatii aditionale</el-button>
        <el-button type="primary" @click="save()"> Salveaza </el-button>
      </span>
    </el-dialog>
    <deviz-produse-dialog ref="deviz_produse_dialog" />

    <Observatii_devize_dialog ref="observatii_devize" @saveObsDialog="saveObsDialog" @closeObsDialog="closeObsDialog" />
  </base-page>
</template>

<script>
import settings from "../../../backend/LocalSettings";
import BasePage from "../../Admin/BasePage.vue";
import TitluPagina from "../../../widgets/TitluPagina.vue";
import Deviz_produse_dialog from "../../../components/Deviz_produse_dialog.vue"
import Observatii_devize_dialog from "../../Receptie/Observatii_devize_dialog.vue";
import CountdownTimer from "./CountdownTimer.vue";

export default {

  name: "dashboard",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    "deviz-produse-dialog": Deviz_produse_dialog,
    Observatii_devize_dialog,
    CountdownTimer
  },
  props: {
    from_deviz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      diametruInitialFata: "",
      diametruInitialSpate: "",
      diametruSimilarValue: false,
      cupluEgal: "1",
      presiuneEgala: "0",
      countdowns: [],
      intervalId: null,
      devize: [{ Id: '', DataRezervarii: '', PresiuneRoti: '', PresiuneRotiSpate: '', Cuplu: '', TipAuto: '', TipAutoModif: '', TipAnvelope: '', DiametruSimilar:false }],
      inspectie: { Id: '', DataRezervarii: '', PresiuneRoti: '', PresiuneRotiSpate: '', Cuplu: '125', TipAuto: '', TipAutoModif: '', TipAnvelope: '', DiametruSimilar:false },
      roti: [{ starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }, { starea_jantei: "", verificata: false, diametru_initial: "" }],
      mod_deviz: { IdDevizModif: '', TipAutoModif: '', TipAnvelope: '', NrRoti: '', CantitateStandard: 0, DiametruSimilar:false },
      showDialogIncheiere: false,
      showDialogMasina: false,
      show_roata_dialog: false,
      tipauto: false,
      wheels_api_key: 'd799c7b539c83028de07532372271f5c',
      indexDeviz: '',
      interval: null,
      displayTorqButton: true,
      clickedDevizIds: [],
      wheelResponseObject: [],
      wheelsModelsData: [],
      stareAnvelopeObj: {},
      diametruOptions: [
        "R10","R11","R12","R13","R14","R15","R16","R17",
        "R18","R19","R20","R21","R22","R23","R24"
      ],
      diametruAnvelopeObj:[],
      diametruFinalFata: "",
      diametruFinalSpate: "",
      Info: {
        Modele: [],
        Marci: [],
      },
    
      wheelApiObject: {
        Model: '',
        Marca: '',
        An: '',
      },
      selectedObject: {
        Observatie: '',
        CheckedObsArr: [],
      },
      temp_roata: {
        index: 0,
        object: {
          starea_jantei: "", verificata: false, diametru_initial: ""
        }
      },
      rules: {
        PresiuneRoti: [{ required: true, message: "Campul este obligatoriu" }],
        PresiuneRotiSpate: [{ required: true, message: "Campul este obligatoriu" }],
        Cuplu: [{ required: true, message: "Campul este obligatoriu" }],
      },
      rules_tip_auto: {
        TipAutoModif: [{ required: true, message: "Campul este obligatoriu" }],
      },
      rulesWheel: {
        An: [{ required: true, message: "Campul este obligatoriu" }],
        Model: [{ required: true, message: "Campul este obligatoriu" }],
        Marca: [{ required: true, message: "Campul este obligatoriu" }],
      },
      noDataFound: false,
      interval: null,
      intervalFirstTime: null,
      base_url_no_index: null,
      audioUrl: '',
      selectedDevizId: null,
      observatiiPredefiniteDetaliate: [],
      Info: {
        Observatii: [],
      },
      updating: false,
    };
  },
  methods: {
    saveObsDialog(payload) {
      const alreadyExists = this.observatiiPredefiniteDetaliate.some(
        (item) => item.observatiePredefinita === payload.observatiePredefinita
      );
      if (!alreadyExists) {
        this.observatiiPredefiniteDetaliate.push(payload);
      }
    },
    closeObsDialog(payload) {
      const alreadyExists = this.observatiiPredefiniteDetaliate.some(
        (item) => item.observatiePredefinita === payload.observatiePredefinita
      );
      if (!alreadyExists) {
        this.observatiiPredefiniteDetaliate.push(payload);
      }
    },
    selectObservatieHandler(newVal) {
      const selected = newVal;
      const previous = this.observatiiPredefiniteDetaliate.map(
        (o) => o.observatiePredefinita
      );

      const removed = previous.filter((obs) => !selected.includes(obs));

      removed.forEach((obsText) => {
        this.observatiiPredefiniteDetaliate =
          this.observatiiPredefiniteDetaliate.filter(
            (item) => item.observatiePredefinita !== obsText
          );
      });

      if (removed.length == 0) {
        const lastAdded = selected[selected.length - 1];
        const lastAddedFromDb = this.Info.Observatii.find(obs => obs.observatie === lastAdded);
        const acceptaCantitate = lastAddedFromDb ? lastAddedFromDb.accepta_cantitate : false;
        const cantitateMaxima = lastAddedFromDb ? lastAddedFromDb.cantitate_maxima : 0;

        this.$refs.observatii_devize.show_me(lastAdded, this.cantitate, acceptaCantitate, cantitateMaxima);
      }
    },
    open() {
      this.$alert('Daca sunt modificari in cadrul produselor de pe deviz, veti fi antentionat printr-un semnal sonor. De asemenea, devizele modificate vor aparea cu fundalul rosu.', 'Atentie', {
        confirmButtonText: 'OK',
        callback: async () => {
          this.setIntervalGetInfo();
        }
      });
    },
    setIntervalGetInfo() {
      clearInterval(this.cerere);
      this.cerere = null;
      this.get_info_devize();
      this.cerere = setInterval(() => this.get_info_devize(), 1000 * 5);
    },

    async fetchSetariAndTriggerAlarmFcn() {
      const response = await this.post("service/devize/get_setari");
      if (response.setari) {
        this.setari = response.setari;
        clearInterval(this.interval);
        this.interval = null;
        this.triggerAlarm(this.setari[0].NumeAlarmaDevize);
        this.interval = setInterval(() => {
          this.triggerAlarm(this.setari[0].NumeAlarmaDevize);
        }, 1000 * this.setari[0].IntervalAlarmaDevize);
      }
    },
    async fetchSetariAndTriggerAlarmFirstTimeDevizFcn() {
      const response = await this.post("service/devize/get_setari");
      if (response.setari) {
        this.setari = response.setari;
        clearInterval(this.intervalFirstTime);
        this.intervalFirstTime = null;
        this.triggerAlarm(this.setari[0].NumeAlarmaDevize);
        this.intervalFirstTime = setInterval(() => {
          this.triggerAlarm(this.setari[0].NumeAlarmaDevize);
        }, 1000 * this.setari[0].IntervalAlarmaDevize);
      }
    },
    getBackgroundStyle(deviz) {
      if (this.$has_right('Supervizor')) {
        return { backgroundColor: '#162d33' };
      } else {
        if ((deviz.LastSeenModificare > deviz.LastSeenMecanic) || (deviz.LastSeenModificare && !deviz.LastSeenMecanic) || (!deviz.LastSeenMecanic && (deviz.DataPreluareInLucru && deviz.NumarProduse != 0))) {
          return { backgroundColor: '#660000' };
        }

        if (this.clickedDevizIds.includes(deviz.Id)) {
          return { backgroundColor: '#162d33' };
        }

        return {};
      }

    },
    handleClick(devizId) {
      if (!this.clickedDevizIds.includes(devizId)) {
        this.clickedDevizIds.push(devizId);

        //chiar daca la urmatorul refresh se va pune automat culoarea.
        const element = document.getElementById(devizId);
        if (element) {
          element.style.setProperty('background-color', '#162d33', 'important');
        }
      }
    },
    hideWheelsInfoHandler() {
      this.displayTorqButton = true;
      this.wheelResponseObject = [];
    },
    add_filter_effect(bool) {
      if (bool) {
        return {
          filter: 'drop-shadow(0px 0px 1.5px green) drop-shadow(0px 0px 1px green) drop-shadow(0px 0px 1px green) drop-shadow(0px 0px 1px green)',
          animation: 'rotating 5s linear infinite'
        };
      } else {
        return {
          filter: 'drop-shadow(0px 0px 1.5px red) drop-shadow(0px 0px 1px red) drop-shadow(0px 0px 1px red) drop-shadow(0px 0px 1px red)'
        };
      }
    },

    valideaza_roti(index, deviz) {
      let roata = this.roti[index];
      let roataFata = false;
      if(index == 0 || index == 2){
        roataFata = true;
      }
      // if ((deviz.CantitateStandard == 1 && roata.starea_jantei != "") || (deviz.CantitateStandard != 1 && roata.starea_jantei != "" && roata.deformari_jante != "")) {
      if (((deviz.CantitateStandard == 1 && roata.starea_jantei != "") || (deviz.CantitateStandard != 1 && roata.starea_jantei != "")) && (roataFata && this.diametruInitialFata != "" || !roataFata && this.diametruInitialSpate != "")) {
        this.roti[index].verificata = true;
        this.roti[index].index = index;
      }
    },

    schimba_tip(type, tip) {

      if (type === "tip") {
        this.mod_deviz.TipAutoModif = tip;
      } else if (type === "anvelope") {
        // this.mod_deviz.TipAnvelope = tip;
      }
    },

    diametru_similar(){
      if(this.diametruSimilarValue && this.mod_deviz.NrRoti < 4){
          this.diametruSimilarValue = false;
          this.$message({ type: 'error', message: 'Programarea nu are roti suficiente pentru a dispune de diametru similar! (Total roti: ' + this.mod_deviz.NrRoti + ')' });
          return;
      }else if(this.diametruSimilarValue && this.mod_deviz.NrRoti >= 4){
          this.diametruInitialSpate = this.diametruInitialFata;
      }
      this.mod_deviz.DiametruSimilar = this.diametruSimilarValue;
    },

    async incepeLucrarea(d, index) {
      await this.get_info();
      // d.TipAnvelope = 'Vechi';
      await this.alegeTipAuto(d, index);
      // if(this.mod_deviz.NrRoti >= 4){
      //   this.diametruSimilarValue = true;
      // }else{
      //   this.diametruSimilarValue = false;
      // }

      this.diametruInitialFata = "";
      this.diametruInitialSpate = "";
      this.diametruSimilarValue = false;

    },

    inputNumberHandler() {
      let numericValue = this.wheelApiObject.An.replace(/\D/g, '');
      numericValue = numericValue.slice(0, 4);
      // daca are mai mult decat anul curent, returneaza anul curent
      if (numericValue > new Date().getFullYear()) {
        numericValue = new Date().getFullYear();
      }
      this.wheelApiObject.An = numericValue;

    },

    async getTorqPressure() {
      this.wheelApiObject.Model = '';
      this.wheelApiObject.Model = '';
      this.wheelApiObject.An = '';
      if (this.devize[this.indexDeviz].An !== 0 && this.devize[this.indexDeviz].An != null) {
        this.wheelApiObject.An = this.devize[this.indexDeviz].An
      } else {
        this.wheelApiObject.An = ''
      }
      if (this.devize[this.indexDeviz].Marca != '' && this.devize[this.indexDeviz].Marca != null) {
        this.wheelApiObject.Marca = this.devize[this.indexDeviz].Marca
        // daca e numeric, vedem in Info.Marci corespondenta si facem conversia in string
        if (!isNaN(Number(this.wheelApiObject.Marca))) {
          const marca = this.Info.Marci.find(m => m.Id == Number(this.wheelApiObject.Marca));
          if (marca) {
            this.wheelApiObject.Marca = marca.Nume;
          } else {
            this.wheelApiObject.Marca = '';
          }
        }
      } else {
        this.wheelApiObject.Marca = ''
      }
      if (this.devize[this.indexDeviz].Model != '' && this.devize[this.indexDeviz].Model != null) {
        this.wheelApiObject.Model = this.devize[this.indexDeviz].Model
        // daca e numeric, vedem in Info.Modele corespondenta si facem conversia in string
        if (!isNaN(Number(this.wheelApiObject.Model))) {
          const model = this.Info.Modele.find(m => m.Id == Number(this.wheelApiObject.Model));
          if (model) {
            this.wheelApiObject.Model = model.Nume;   
          } else {
            this.wheelApiObject.Model = '';
          }
        }
      } else {
        this.wheelApiObject.Model = ''
      }

      this.wheelResponseObject = []
      this.noDataFound = false;
      this.wheelsModelsData = [];
      this.displayTorqButton = false;

    },

    async sendInfoToWheelApi() {
      this.$refs['my-wheel-form'].validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          try {
            this.noDataFound = false;
            const response = await this.get(`https://api.wheel-size.com/v2/search/by_model/?make=${this.wheelApiObject.Marca}&model=${this.wheelApiObject.Model}&year=${this.wheelApiObject.An}&region=eudm&user_key=${this.wheels_api_key}`);
            loading.close();
            this.wheelResponseObject = response

            // daca nu primeste raspuns de la api-ul de anvelope
            if (this.wheelResponseObject.data.length == 0) {
              this.$message({ type: 'error', message: 'Nu s-au gasit informatii pentru aceasta masina. Selecteaza unul dintre modelele de mai jos!' });
              this.wheelResponseObject = [];
              this.noDataFound = true;
              this.wheelApiObject.Model = '';
              const response_models = await this.get(`https://api.wheel-size.com/v2/models/?make=${this.wheelApiObject.Marca}&year=${this.wheelApiObject.An}&region=eudm&user_key=${this.wheels_api_key}`);
              if (response_models.data.length != 0) {
                this.wheelsModelsData = []
                response_models.data.forEach((model) => {
                  let obj = {
                    'value': model.slug,
                    'label': model.name,
                  }

                  this.wheelsModelsData.push(obj);
                })

              }

              return;
            }

            this.wheelResponseObject.data.forEach((obj) => {
              let frontTierPressure = ''
              let rearTierPressure = ''
              let frontTierType = ''
              let rearTierType = ''
              obj.wheels.forEach((wheel) => {
                if (frontTierPressure == '') {
                  if (wheel.front.tire_pressure != null) {
                    if (wheel.front.tire_pressure.bar != null) {
                      frontTierPressure += wheel.front.tire_pressure.bar
                    } else {
                      frontTierPressure += "-"
                    }
                  } else {
                    wheel.front.tire_pressure = { bar: "-" }
                  }
                } else {
                  if (wheel.front.tire_pressure != null) {
                    if (wheel.front.tire_pressure.bar != null) {
                      frontTierPressure += ' | ' + wheel.front.tire_pressure.bar
                    } else {
                      frontTierPressure += " | " + "-"
                    }
                  } else {
                    wheel.front.tire_pressure = { bar: "-" }
                  }
                }

                if (rearTierPressure == '') {
                  if (wheel.rear.tire_pressure != null) {
                    if (wheel.rear.tire_pressure.bar != null) {
                      rearTierPressure += wheel.front.tire_pressure.bar
                    } else {
                      rearTierPressure += "-"
                    }
                  } else {
                    wheel.rear.tire_pressure = { bar: "-" }
                  }
                } else {
                  if (wheel.rear.tire_pressure != null) {
                    if (wheel.rear.tire_pressure.bar != null) {
                      rearTierPressure += ' | ' + wheel.rear.tire_pressure.bar
                    } else {
                      rearTierPressure += " | " + "-"
                    }
                  } else {
                    wheel.rear.tire_pressure = { bar: "-" }
                  }
                }

                if (frontTierType == '') {
                  if (wheel.front.tire !== null) {
                    frontTierType += wheel.front.tire;
                  } else {
                    frontTierType += '-'
                  }
                } else {
                  if (wheel.front.tire !== null) {
                    frontTierType += ' | ' + wheel.front.tire
                  } else {
                    frontTierType += ' | ' + '-'
                  }
                }

                if (rearTierType == '') {
                  if (wheel.rear.tire !== null) {
                    rearTierType += wheel.rear.tire;
                  } else {
                    rearTierType += '-'
                  }
                } else {
                  if (wheel.rear.tire !== null) {
                    rearTierType += ' | ' + wheel.rear.tire
                  } else {
                    rearTierType += ' | ' + '-'
                  }
                }
              })

              obj.frontTierType = frontTierType;
              obj.rearTierType = rearTierType;
              obj.frontTierPressure = frontTierPressure;
              obj.rearTierPressure = rearTierPressure;
            })
          } catch (error) {
            this.$message({ type: 'error', message: 'A intervenit o eroare in obtinerea informatiilor necesare.' });
            loading.close();
          }

          if (this.noDataFound) {
            this.displayTorqButton = false;
          } else {
            this.displayTorqButton = true;
          }

          this.wheelApiObject = {
            An: '',
            Model: '',
            Marca: ''
          }
        }
      });

    },
    saveWheelInfo(obj, cuplu) {

      this.inspectie.PresiuneRoti = obj.front.tire_pressure.bar;
      this.inspectie.PresiuneRotiSpate = obj.rear.tire_pressure.bar;
      this.inspectie.Cuplu = cuplu.replace(/\D/g, '');
      this.inspectie.CupluSpate = this.inspectie.Cuplu;

    },


    inchide_deviz(d, index) {

      this.$prompt("Acest deviz va fi inchis cu statusul 'Lipsa operatiune'. Programarea va fi anulata! Va rugam sa specificati motivul", "Inchidere deviz", {
        confirmButtonText: 'Inchide deviz',
        cancelButtonText: 'Renunta',
      }).then(async ({ value }) => {

        let response = await this.post('receptie/devize/inchide_deviz_lipsa_operatiune', { idDeviz: d.Id, Motiv: value });
        if (response.success == 1) {
          this.$message({ type: 'success', message: 'Devizul a fost anulat cu success.' });
          this.refresh_info();
        } else {
          this.$message({ type: 'error', message: 'A intervenit o eroare in inchiderea devizului' });
        }
      }).catch(() => { });

    },

    async inchideDialogMasina(IdDevizDeschis) {

      let res = await this.post("service/devize/deblocare_programare", { IdDeviz: IdDevizDeschis });
      if (res.success == 1) this.$message({ message: 'Programarea a fost deblocata!', type: 'success' });

      this.showDialogMasina = false;

    },


    async alegeTipAuto(d, index) {

      this.displayTorqButton = true;
      this.tipauto = true;
      this.wheelResponseObject = []
      this.indexDeviz = index;
      var incearca_blocare = await this.post("service/devize/blocare_programare", { IdDeviz: d.Id });
      if (incearca_blocare.success == 1) {
        this.$message({ message: "Acest deviz este blocat pana la inchiderea ferestrei. Doar supervizorul poate prelua controlul asupra lui", type: 'warning' });
      } else {
        this.$message({ message: incearca_blocare.error, type: 'error' });
        return;
      }

      this.mod_deviz.IncludeRotiInInspectie = d.IncludeRotiInInspectie;
      this.mod_deviz.IdDevizModif = d.Id;
      this.mod_deviz.TipAutoModif = d.TipAuto;
      // this.mod_deviz.TipAnvelope = d.TipAnvelope;
      this.mod_deviz.NrRoti = d.NumarRoti;
      this.mod_deviz.AscundeTipAnvelope = d.AscundeTipAnvelope;
      this.mod_deviz.CantitateStandard = d.CantitateStandard;
      this.mod_deviz.ObtineInformatiiAditionale = d.ObtineInformatiiAditionale;

    

      // console.log("d:",d.AscundeTipAnvelope);

      this.showDialogMasina = true;
      if (d.StareRoti == null || d.StareRoti == 'null') {
        this.roti = [{ starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }, { starea_jantei: "", verificata: false, diametru_initial:"" }];
        this.diametruInitialFata = "";
        this.diametruInitialSpate = "";
      } else {
        this.roti = JSON.parse(d.StareRoti);

        this.roti.forEach((roata, index) => {
          if (roata.verificata && !roata.index) {
            roata.index = index;
          }
          if (roata.verificata == 'true') {
            roata.verificata = true;
          }
          else if (roata.verificata == 'false') {
            roata.verificata = false;
          }

          if((index == 0 || index == 2) && roata.diametru_initial){
            this.diametruInitialFata = roata.diametru_initial;
          }else if((index == 1 || index == 3) && roata.diametru_initial){
            this.diametruInitialSpate = roata.diametru_initial;
          }
        });

        if(this.diametruInitialFata && this.diametruInitialFata == this.diametruInitialSpate){
          this.diametruSimilarValue = true;
        }else{
          this.diametruSimilarValue = false;
        }
      }

    },
    goleste: async function (deviz, index) {
      this.devize[index].NumarProduse = 0;
      let res = await this.post("service/devize/goleste_deviz", { idDeviz: deviz.Id });
      if (res.success == 1) this.$message({ message: 'Devizul este gol!', type: 'success' });
      else this.$message({ message: res.error, type: 'error' });
    },
    async validare_deviz(deviz, index) {

      this.stareAnvelopeObj = {},
      this.diametruAnvelopeObj = [];
      this.indexDeviz = index;

      this.displayTorqButton = true;
      this.tipauto = false;
      this.wheelApiObject = {
        Model: '',
        Marca: '',
        An: '',
      }
      this.wheelResponseObject = []

      let stareRoti = JSON.parse(this.devize[index].StareRoti);
      this.diametruFinalFata = "";
      this.diametruFinalSpate = "";

      let indexArray = stareRoti.filter((element) => element.hasOwnProperty('index')).map((element) => element.index);
      this.stareAnvelopeObj = indexArray.map(index => {
        return {
          index: index,
          valoare: (deviz && deviz.SursaComanda != 0 ? 'Noua' : ''),
        };
      });


      this.diametruAnvelopeObj = indexArray.map(index => {
        return {
          index: index,
          diametru_final: stareRoti[index]?.diametru_initial || ''
        };
      });

      indexArray.forEach(index => {
        const diametruInitial = stareRoti[index]?.diametru_initial;

        if (diametruInitial) {
          if (index == 0 || index == 2) {
            console.log("aici");
            this.diametruFinalFata = diametruInitial;
          } else if (index == 1 || index == 3) {
            this.diametruFinalSpate = diametruInitial;
          }
        }
      });

      if (parseInt(deviz.IncludeRotiInInspectie) === 1) {
        this.inspectie = this.devize[index];
        this.inspectie.PresiuneRoti = '2.2';
        this.inspectie.PresiuneRotiSpate = '2.2';
        this.inspectie.Antifurt = 0;
        this.inspectie.Cuplu = '120';
        this.inspectie.CupluSpate = '120';

        this.selectedObject = {
          Observatie: '',
          CheckedObsArr: [],
        };
        this.observatiiPredefiniteDetaliate = [];

        this.cupluEgal = "1";
        this.presiuneEgala = "0";
        this.showDialogIncheiere = true;

      } else {
        this.inspectie = this.devize[index];
        this.inspectie.PresiuneRoti = null;
        this.inspectie.PresiuneRotiSpate = null;
        this.inspectie.Antifurt = null;
        this.inspectie.Cuplu = null;
        this.inspectie.CupluSpate = null;
        let res = await this.post("service/Devize/inchide_deviz", { deviz: this.inspectie, });
        if (res.success == 1) {
          this.$message({ message: 'Devizul a fost finalizat', type: 'success' });
        } else {
          this.$message({ message: res.error, type: 'error' });
        }
        this.get_info();
      }
    },

    save: async function (deviz, index) {
      const isInvalid = this.stareAnvelopeObj.some(stare => {
        if (!stare.valoare || stare.valoare === '') {
          this.$message({ message: 'Alege starea pentru anvelopa #' + (Number(stare.index) + 1), type: 'error' });
          return true;
        }
        return false;
      });

      if (isInvalid) {
        return;
      }

      let diametruValidationError = false;

      this.diametruAnvelopeObj.forEach(item => {
        if(item.index == 0 || item.index == 2){
          if(!this.diametruFinalFata){
            diametruValidationError = true;
            this.$message({ message: 'Alege diametrul pentru anvelopa #' + (Number(item.index) + 1), type: 'error' });
            return;
          }
          if(item.diametru_final){
            item.diametru_final = this.diametruFinalFata;
          }
        }else if(item.index == 1 || item.index == 3){
          if(!this.diametruFinalSpate){
            diametruValidationError = true;
            this.$message({ message: 'Alege diametrul pentru anvelopa #' + (Number(item.index) + 1), type: 'error' });
            return;
          }
          if(item.diametru_final){
            item.diametru_final = this.diametruFinalSpate;
          }
        }else{
          if(!item.diametru_final){
            diametruValidationError = true;
            this.$message({ message: 'Alege diametrul pentru anvelopa #' + (Number(item.index) + 1), type: 'error' });
            return;
          }
        }
      });

      if(diametruValidationError){
        return;
      } 


      const obsJsonArr = []
      obsJsonArr.push({ observatie: this.selectedObject.Observatie })
      obsJsonArr.push({ observatiiPreselectate: this.observatiiPredefiniteDetaliate })

      if (this.inspectie.CantitateStandard == 1) {
        this.inspectie.Cuplu = null;
        this.inspectie.CupluSpate = null;
        this.inspectie.Antifurt = 0;
      }

      if(this.inspectie.CupluInInspectie == '0'){
        this.inspectie.Cuplu = null;
        this.inspectie.CupluSpate = null;
      }

      this.$refs['my-form'].validate(async (valid) => {
        if (valid) {
          let res = await this.post("service/Devize/inchide_deviz", { deviz: this.inspectie, stareAnvelope: this.stareAnvelopeObj, observatii: JSON.stringify(obsJsonArr), diametruAnvelope: this.diametruAnvelopeObj });
          if (res.success == 1) {
            this.$message({ message: 'Devizul a fost finalizat', type: 'success' });
          } else {
            this.$message({ message: res.error, type: 'error' });
          }


          this.showDialogIncheiere = false;
          this.get_info();
        }
      });
    },
    modifica_roata: function (index) {
      if (window.innerWidth <= 855 || index > 3) {
        this.show_roata_dialog = true;
        let roata = this.roti[index];
        this.temp_roata = {
          index: index,
          object: roata
        };
      } else {
        return;
      }
    },

    save_roata: async function () {
      let index = this.temp_roata.index;
      let object = this.temp_roata.object;
      if (object.starea_jantei != "" && object.diametru_initial != "") {
        object.verificata = true;
      }else{
        object.verificata = false;
        this.$message({ message: 'Completeaza toate campurile pentru a valida roata!', type: 'error' });
        return;
      }
      this.roti[index] = object;

      this.inchide_roata();
    },

    inchide_roata: async function () {
      this.show_roata_dialog = false;
      this.temp_roata = {
        index: "0",
        object: {
          starea_jantei: "",
          diametru_initial: "",
        }
      }
    },

    schimba_tip_auto: async function () {
      var valid = true;

      if (this.mod_deviz.CantitateStandard != 1 && this.roti.filter(roata => roata.verificata == true).length != this.mod_deviz.NrRoti && this.mod_deviz.IncludeRotiInInspectie == 1) {
        valid = false;
        this.$message({ message: `Roti de completat: ${Number(this.mod_deviz.NrRoti) - Number(this.roti.filter(roata => roata.verificat).length)}`, type: 'error' });
      }
      if (!valid) return;

      this.roti.forEach((roata, index) => {
        if (roata.verificata) {
          if (index === 0 || index === 2) {
            roata.diametru_initial = this.diametruInitialFata;
          } else if (index === 1 || index === 3) {
            roata.diametru_initial = this.diametruInitialSpate;
          }
        }
      });
      // if(this.mod_deviz.AscundeTipAnvelope === '1'){
      //   this.mod_deviz.TipAnvelope = null
      // }
      let res = await this.post("service/Devize/schimba_tip_auto", { deviz: this.mod_deviz, roti: this.roti });
      if (res.success == 1) {
        if (res.produse_actualizate > 0) this.$message({ message: 'Au fost actualizate preturile pentru ' + res.produse_actualizate + ' produse', type: 'success' });

        await this.inchideDialogMasina(this.mod_deviz.IdDevizModif)
        this.mod_deviz = { IdDevizModif: '', TipAutoModif: '', TipAnvelope: '' };
        // this.get_info();

        this.showDialogMasina = false;
      } else if (res.error) {
        this.$message({ message: res.error, type: 'error' });
      }

      this.get_info();
    },

    async triggerDeviz(nume, id, deviz) {
      try {
        this.handleClick(id);
        this.selectedDevizId = id;
        const response_first_time = await this.post("service/devize/get_last_seen_mecanic", { devizId: id });
        if (!response_first_time['LastSeenMecanic']) {
          this.$refs.deviz_produse_dialog.show_me(id, true, deviz);
          // if (!this.intervalFirstTime) {
          //   this.fetchSetariAndTriggerAlarmFirstTimeDevizFcn()
          // }
          this.$alert('Confirm produsul din deviz si operatiunile aferente acestuia', 'Atentie', {
            confirmButtonText: 'Confirm',
            callback: async () => {
              clearInterval(this.intervalFirstTime);
              this.intervalFirstTime = null;
              this.$refs.deviz_produse_dialog.stop_loading();
            }
          });
        } else if (response_first_time['LastSeenModificare']) {
          this.$refs.deviz_produse_dialog.show_me(id, true, deviz);
          this.$alert('Confirm modificarile aduse devizului si operatiunile aferente acestuia.', 'Atentie', {
            confirmButtonText: 'Confirm',
            callback: async () => {
              this.$refs.deviz_produse_dialog.stop_loading();
            }
          });
        } else {
          this.$refs.deviz_produse_dialog.show_me(id, false, deviz);
        }
        // this.$router.push({name: nume, params: { id: id }})
        const response = await this.post("service/devize/update_last_seen_mecanic", { devizId: id });
      } catch (error) {
        console.error(error)
      }
    },

    async get_info() {
      // console.log("GET INFO");
      var response = await this.post("service/devize/get_devize_draft");
      if (response.devize) {
        this.devize = response.devize;
        this.Info.Marci = response.Marci;
        this.Info.Modele = response.Modele;

      }
    },
    async get_info_devize() {
      try {
        const response = await this.post("service/devize/get_devize_draft");
        if (response.devize) {
          this.devize = response.devize;
        }

        let alarmDeviz = false;

        for (let index = 0; index < this.devize.length; index++) {
          if ((this.devize[index].LastSeenModificare > this.devize[index].LastSeenMecanic) || (this.devize[index].LastSeenModificare && !this.devize[index].LastSeenMecanic) || (!this.devize[index].LastSeenMecanic && (this.devize[index].DataPreluareInLucru && this.devize[index].NumarProduse != 0))) {
            alarmDeviz = true;
            if(!this.interval){
              this.fetchSetariAndTriggerAlarmFcn();
              this.interval = true;
            } 
            break;
          }
        }

        if (!alarmDeviz) {
          clearInterval(this.interval);
          this.interval = false;
        } else {
          if (!this.interval) {
            this.fetchSetariAndTriggerAlarmFcn()
          }
        }
        const exista_deviz = this.devize.find((deviz) => deviz.Id === `${this.selectedDevizId}` && (deviz.IdUtilizatorBlocare && deviz.IdUtilizatorBlocare != deviz.IdMecanic));
        if (exista_deviz) {
          this.selectedDevizId = null;
          if (this.$refs.deviz_produse_dialog.check_dialog_status()) {

            const response_u = await this.post("service/devize/get_utilizator_blocare", { id: exista_deviz.IdUtilizatorBlocare })
            if (response_u.NumeUtilizator) {
              this.$message({ message: "Devizul a fost preluat de catre " + response_u.NumeUtilizator + "!", duration: 8000, type: 'error' });
            }
            this.$refs.deviz_produse_dialog.close_dialog();
          }
        }
      } catch (error) {
        console.error(error)
      }
    },

    triggerAlarm(nume) {
      // console.log("triggered");
      this.audioUrl = this.base_url_no_index + 'assets/doc_audio/' + nume;
      console.log("Audio URL:", this.audioUrl);
      var audio = new Audio(this.audioUrl);
      audio.play();
    },

    async fetchObservatii() {
      try {
        this.Info.Observatii = [];
        const response = await this.post("receptie/devize/get_observatii_deviz")
        this.Info.Observatii = response.observatii;
      } catch (error) {
        console.error(error)
      }
    },
    updateCountdowns() {
      const now = new Date()
      this.countdowns = this.devize.map(d => {
        if (!d.DataPreluareInLucru) {
          return null
        }

        const start = new Date(d.DataPreluareInLucru)
        const end = new Date(start.getTime() + d.DurataMin * 60000)
        return end - now
      })
    },
  },
  watch: {
    presiuneEgala(val) {
      if (val == "1") {
        this.inspectie.PresiuneRotiSpate = this.inspectie.PresiuneRoti;
      }
    },
    'inspectie.PresiuneRoti'(val) {
      if (this.presiuneEgala == "1") {
        this.inspectie.PresiuneRotiSpate = val;
      }
    },
    cupluEgal(val) {
      if (val == "1") {
        this.inspectie.CupluSpate = this.inspectie.Cuplu;
      }
    },
    'inspectie.Cuplu'(val) {
      if (this.cupluEgal == "1") {
        this.inspectie.CupluSpate = val;
      }
    },
    diametruInitialFata(val) {
      if(this.diametruSimilarValue){
        this.diametruInitialSpate = val;
      }

      this.roti.forEach((roata, index) => {
        this.valideaza_roti(index, this.mod_deviz);
      });
    },

    diametruInitialSpate(val) {
      this.roti.forEach((roata, index) => {
        this.valideaza_roti(index, this.mod_deviz);
      });
    },

  },
  async mounted() {
    if (!this.$has_right('Mecanic') && !this.$has_right('Supervizor')) {
      this.$router.push('/no-rights')
      return
    }
    this.updateCountdowns()
    this.intervalId = setInterval(this.updateCountdowns, 1000)


    // console.log("this.from:",this.from_deviz);

    if (window.location.href.includes("localhost") || window.location.href.includes("dev")) {
      this.base_url_no_index = settings.BASE_URL_NO_INDEX;
    } else {
      this.base_url_no_index = settings.BASE_URL_NO_INDEX_PROD;
    }

    await this.fetchObservatii();

    this.selectedDevizId = null;
    this.select_menu_item('devize');
    this.get_info();

  },

  created() {
    if (this.$has_right('Mecanic')) {
      this.open();
    }
  },



  beforeRouteLeave(to, from, next) {
    if (this.cerere) {
      clearInterval(this.cerere);
      this.cerere = null
    }

    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null
    }

    clearInterval(this.intervalId)
    next()
  },
  beforeDestroy() {
    if (this.cerere) {
      clearInterval(this.cerere);
      this.cerere = null
    }
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null
    }

    clearInterval(this.intervalId)
  },

};
</script>

<style lang="less" scoped>
.width-30 {
  width: 30%;
}

.btn-auto-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.inspectie {
  display: flex;
}


.select-container {
  text-align: center;
  margin: 0 auto;
  margin-bottom: 20px;
}


.btn-auto {
  width: 20%;
  height: 45px;
  font-size: 14px;
}



.main-div {
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}

.butoane-tip {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}




.top50 {
  margin-top: 20px;

}

.tag-logged {
  font-size: 12px;
  opacity: 0.5;
}

.menu {
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5%;
  align-items: center;
}

.new-file {
  width: 390px;
  height: 270px;
  background-color: #162d33;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.roti-suplimentare {
  margin: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    font-size: 14px;
    text-align: center;
  }

  .roti-list {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 15px;

    .roata {
      width: 70px;
      height: 70px;
      cursor: pointer;
    }
  }
}

.masina {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  box-sizing: border-box;
  margin-top: 50px;

  .left {
    padding: 15px 0;

    height: 400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 15px;

    .roata {

      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: row;
      gap: 15px;


      .chestionar {
        width: 350px;
        height: 200px;
        padding: 10px;
        display: flex;
        justify-content: space-evenly;
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;

        p {
          font-weight: 600;
        }

        // border: 1px solid red;
        border-radius: 5px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.457);
      }

      img {
        cursor: pointer;
        width: 70px;
        height: 70px;
      }
    }
  }

  .center {

    img {

      width: 150px;
      height: 400px;
    }
  }

  .right {
    padding: 15px 0;
    height: 400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 15px;

    .roata {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: row-reverse;
      gap: 15px;

      .chestionar {
        width: 350px;
        height: 200px;
        padding: 10px;
        display: flex;
        justify-content: space-evenly;
        align-items: flex-start;
        flex-direction: column;
        border-radius: 5px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.457);
        gap: 10px;
      }

      img {
        cursor: pointer;
        width: 70px;
        height: 70px;
      }
    }
  }
}

.deviz {
  width: 390px;
  height: 365px;
  background-color: #162d33;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  color: white;
}

.header {
  padding: 15px 10%;
  width: 100%;
  height: 33%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.ora {
  height: 10% !important;
}

.header p {
  margin: 0 auto;
  padding: 0;

}

.main {
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0;
}

.rejectat {
  margin: 10px 0;
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;

}

.el-card__body {
  margin: 0;
  padding: 0;
}

.rejectat .el-button {
  width: 82%;
}

.mic {
  width: 80%;
  height: 100%;
  margin: 0;
  margin-top: 5px;
}

.mesaj-respins {
  color: #F56C6B;
  text-align: center;
  font-size: 14px;

}

.mare {
  width: 80%;
  height: 100%;

}

.main-new {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-new .el-button {
  width: 48%;
  height: 40%;
}

.old-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer {
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5%;
}

.footer .el-button {
  width: 38.6%;
  height: 80%;
}

.print {
  width: 100%;
  text-align: center;
}

.buton-fisa-noua {
  border-radius: 20px;
  width: 75%;
  height: 75%;
}

.el-radio-button__inner {
  padding: 5vw !important;
}

@media only screen and (max-width:767px) {
  .btn-auto-group {
    flex-direction: column;
  }
}

.deviz-source-title{
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
}

.deviz-row{
    font-size:14px;
    padding: 8px;
  }

@media only screen and (max-width: 855px) {

  .deviz-row{
    font-size:10px;
    padding:10px;
  }

  .deviz-source-title{
    font-size: 12px;
  }
  .masina {
    .left {
      .roata {
        .chestionar {
          display: none;
        }

      }
    }

    .center {}

    .right {
      .roata {
        .chestionar {
          display: none;
        }

      }
    }
  }

  .input-inspectie {
    width: 100%;
  }

  .inspectie {
    flex-direction: column;
  }

  .main-div {

    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .new-file {
    width: 290px;
    height: 170px;
    margin: 10px 10px;
  }

  .deviz {
    width: 280px;
    height: 300px;

    margin: 10px 10px;
  }

  .cant_span {
    font-size: 10px;
  }

  .deviz .el-button {
    font-size: 11px;

  }

  .header {
    font-size: 11px;
  }

  .main {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    // height: 60%;
  }

  .mic {
    height: 100%;
  }


  .footer .el-button {
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-auto-group {}

  .select-container {
    text-align: center;
  }

  .btn-auto {
    margin: 0;
    width: 70%;
    height: 45px;

  }

  .el-card__body {
    padding: 0;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);

  }

  to {
    transform: rotate(360deg);
  }
}
</style>
